import { Cancel } from '@mui/icons-material';
import { Button, CardContent, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import SimpleCard from '../../../../../components/SimpleCard';
import { APP_ROUTES } from '../../../../../constants/app-routes';

export default function Denied() {
  const navigate = useNavigate();
  const { currentBooking } = useSelector((store) => store.vendorRetail);

  const handleBackToDashboard = () => {
    navigate(APP_ROUTES.DASHBOARD);
  };

  const handleBrowseOpportunities = () => {
    navigate(APP_ROUTES.DASHBOARD); // Or route to retail opportunities page
  };

  return (
    <div>
      <Grid container justifyContent="center" marginBottom={2}>
        <Grid item>
          <Typography fontWeight="bold">Application Denied</Typography>
        </Grid>
      </Grid>

      <SimpleCard variant="outlined">
        <CardContent>
          <Grid container justifyContent="center" textAlign="center">
            <Grid item xs={12}>
              <Cancel
                sx={{
                  fontSize: 80,
                  color: '#DC3545',
                  marginBottom: 2,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h5" fontWeight="bold" marginBottom={2}>
                Unfortunately, your application was not approved
              </Typography>

              <Typography variant="body1" color="text.secondary" marginBottom={3}>
                The venue owner has decided not to approve your booking request at this time.
              </Typography>

              {currentBooking && (
                <div style={{ marginBottom: '2rem' }}>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Requested Date:</strong>{' '}
                    {moment(currentBooking.booking_date).format('MMM DD, YYYY')}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Time:</strong> {currentBooking.start_time} - {currentBooking.end_time}
                  </Typography>
                </div>
              )}

              <Typography variant="body2" color="text.secondary" marginBottom={3}>
                Don&apos;t worry! There are many other retail space opportunities available. Feel
                free to browse and apply for other venues.
              </Typography>

              <Grid container spacing={2} justifyContent="center">
                <Grid item>
                  <Button
                    variant="outlined"
                    size="large"
                    onClick={handleBackToDashboard}
                    sx={{
                      borderColor: '#EE7B57',
                      color: '#EE7B57',
                      '&:hover': {
                        borderColor: '#d66a47',
                        bgcolor: 'rgba(238, 123, 87, 0.04)',
                      },
                      px: 4,
                      py: 1.5,
                    }}>
                    Back to Dashboard
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleBrowseOpportunities}
                    sx={{
                      bgcolor: '#EE7B57',
                      '&:hover': {
                        bgcolor: '#d66a47',
                      },
                      px: 4,
                      py: 1.5,
                    }}>
                    Browse More Opportunities
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </SimpleCard>
    </div>
  );
}
